import React from "react";
import StarIcon from "@mui/icons-material/Star";

const index = () => {
  return (
    <div className="bg-white py-2 flex items-center justify-center shadow-lg">
      <a
        href="https://www.bbb.org/us/tx/san-antonio/profile/credit-and-debt-counseling/debt-redemption-dba-affordable-debt-consolidation-0825-90006140"
        className="me-4"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src="/svgs/BBB.svg"
          className="w-full h-16 sm:h-auto"
          alt="BBB Logo"
        />
      </a>
      <p className="text-md font-normal hidden sm:block">Our customers say</p>
      <p className="text-lg font-semibold mx-3 hidden sm:block">Excellent</p>
      <div className="flex items-center me-3">
        {[1, 2, 3, 4, 5].map((index) => (
          <div className="p-1 bg-custom-primary me-1 flex" key={index}>
            <StarIcon className="text-white text-sm" />
          </div>
        ))}
      </div>
      <p className="hidden md:block font-bold text-xs lg:text-lg">
        A+ BBB Rating with Zero Complaints
      </p>
    </div>
  );
};

export default index;
